// extracted by mini-css-extract-plugin
module.exports = {"container":"_25E_muJMIoxQEN-VPS_SoQ","inner":"_1fREpQt_ierl12-Jebs7y5","content":"_2zrUvIMHRvY-4jseD_JI49","intro":"_24BI65C3Uk-8Ceut5wypMx","heading":"_3ZBfm6m_YdlnU61uw9wMv7"};